<template>
  <v-layout wrap>
    <v-flex
      flex-grow-1
      xs12
    >
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">
              Добавление пользователя
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form>
              <v-layout wrap>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    v-model="user.username"
                    v-validate="'required'"
                    label="Логин"
                    name="login"
                    data-vv-as="Логин"
                    :error-messages="errors.collect('login')"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    v-model="user.first_name"
                    label="Имя"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    v-model="user.last_name"
                    label="Фамилия"
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-chips-combobox
                    :model="user.groups"
                    :items="permissionsGroups"
                    item-text="name"
                    item-value="permissions_group_id"
                    label="Группа"
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    ref="password1"
                    v-model="user.password"
                    v-validate="'required|min:8'"
                    :error-messages="errors.first('password1')"
                    :append-icon="showPassword1 ? 'visibility' : 'visibility_off'"
                    :type="showPassword1 ? 'text' : 'password'"
                    name="password1"
                    data-vv-as="Пароль"
                    label="Пароль"
                    @click:append="showPassword1 = !showPassword1"
                  />
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    v-model="confirmed_password"
                    v-validate="'required|confirmed:password1'"
                    :error-messages="errors.first('password2')"
                    :append-icon="showPassword2 ? 'visibility' : 'visibility_off'"
                    :type="showPassword2 ? 'text' : 'password'"
                    name="password2"
                    data-vv-as="повторного пароля"
                    label="Повторите пароль"
                    @click:append="showPassword2 = !showPassword2"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click.native="saveChanges"
          >
            Сохранить
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click.native="cancelEditing()"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import VChipsCombobox from '../../shared-components/VChipsCombobox'
import axios from 'axios'
export default {
  name: 'UserNew',
  components: {
    VChipsCombobox
  },
  props: {
    userData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      valid: true,
      email_primary: null,
      user: { username: '', first_name: '', last_name: '', password: '', groups: [] },
      users_groups: [],
      showPassword1: false,
      showPassword2: false,
      confirmed_password: '',
      permissionsGroups: []
    }
  },
  mounted () {
    this.getPermissionsGroupsApi()
  },
  methods: {
    cancelEditing: function () {
      this.$emit('cancel')
    },
    getPermissionsGroupsApi () {
      this.loading = true
      axios.get(`/api/permissions_groups/?per_page=100`)
        .then((response) => {
          this.permissionsGroups = response.data.results
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    saveChanges () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.axios.post(`/api/users/`, this.user)
            .then(() => {
              this.$emit('added')
            })
            .catch((err) => {
              console.log(err)
            })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/user/UserNew.vue